var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex border rounded shadow border-gray-lightest animate-pulse",class:{
    'flex-row gap-6 lg:gap-16': _vm.isHorizontal,
    'flex-col': _vm.isVertical,
  },attrs:{"role":"status"}},[_c('div',{staticClass:"flex items-center justify-center rounded bg-gray-lightest",class:{
      'h-[326px] w-1/2': _vm.isHorizontal,
      'h-[210px] w-full': _vm.isVertical,
    }}),_vm._v(" "),_c('div',{staticClass:"p-4",class:{
      'w-1/2': _vm.isHorizontal,
      'w-full': _vm.isVertical,
    }},[_c('div',{staticClass:"h-9.6 bg-gray-lightest rounded w-[80%] mb-4"}),_vm._v(" "),_c('div',{staticClass:"h-9 bg-gray-lightest rounded mb-[2px] w-full"}),_vm._v(" "),_c('div',{staticClass:"h-9 bg-gray-lightest rounded mb-[2px] w-full"}),_vm._v(" "),_c('div',{staticClass:"h-9 bg-gray-lightest rounded w-[60%] mb-4"}),_vm._v(" "),_c('div',{staticClass:"h-9 rounded bg-gray-lightest w-[40%]"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }